<mat-card class="example-card">
  <mat-card-header>
    <div
      mat-card-avatar
      class="example-header-image"
      [style.background-image]="image"
    ></div>
    <mat-card-title>{{ node.titulo }}</mat-card-title>
    <!-- <mat-card-subtitle>{{ node.subtitulo }}</mat-card-subtitle> -->
    <div>
      <button
        mat-raised-button
        class="primary-btn rounded botonSl"
        (click)="socialLinkSearch()"
      >
        Busqueda en Social Link
      </button>
      <button class="close" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <!-- <mat-card-content>
    <div class="grid">
      <div *ngFor="let data of keys">
        <p class="keyClass">
          {{ data.key }} : <span class="value">{{ data.value }}</span>
        </p>
      </div>
    </div>
    <p>
      {{ node.descripcion }}
    </p>
  </mat-card-content> -->
  <mat-card-content>
    <div class="grid">
      <div *ngFor="let data of keys" class="grid-item">
        <p class="keyClass">
          {{ data.key }} : <span class="value">{{ data.value }}</span>
        </p>
        <button
          *ngIf="data.category"
          mat-raised-button
          class="primary-btn rounded botonCategory"
          (click)="socialLinkSearch(data.category, data.value)"
        >
          Búsqueda por nombre
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
